export const comments_5618936 = {"data":{"data":[],"links":{}}}